// extracted by mini-css-extract-plugin
export default {"panel":"FactDataAgreementPanel_panel__2JXaD","recordDetails":"FactDataAgreementPanel_recordDetails__GPDvq","recordRow":"FactDataAgreementPanel_recordRow__KFixv"};